export default "__VITE_ASSET__cGl0zyk$__"